
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bundlers",
      function () {
        return require("private-next-pages/bundlers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bundlers"])
      });
    }
  